import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { DreamSection } from '../components/DreamSection';
import { WhyFailsSection } from '../components/WhyFailsSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { FooterSection } from '../components/FooterSection';
import { SalesNotification } from '../components/SalesNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-zinc-950 text-white" data-id="element-430">
      <StickyHeader data-id="element-431" />
      <HeroSection data-id="element-432" />
      <PainSection data-id="element-433" />
      <DreamSection data-id="element-434" />
      <WhyFailsSection data-id="element-435" />
      <MechanismSection data-id="element-436" />
      <ProductSection data-id="element-437" />
      <BenefitsSection data-id="element-438" />
      <GuaranteeSection data-id="element-439" />
      <FAQSection data-id="element-440" />
      <FinalCTASection data-id="element-441" />
      <FooterSection data-id="element-442" />
      <SalesNotification data-id="element-443" />
    </div>;
}